export default "__VITE_ASSET__B_BDpZ8W__"